<template>
  <div
    class="mask"
  >
    <div class="mask-content flex" :style="{ height: height ? height + 'px' : '', 'margin-left': -left + 'px' }">
      <div class="icon-wrap flex">
        <div class="icon-item flex" v-for="(icon, index) in iconArr" :key="index">
          <img :src="icon.img" />
          <p>{{ icon.name }}</p>
        </div>
      </div>
      <p class="explain">{{$vi18n('$i18n# 成为迷你世界正式创作者，就能使用账号管理及收益管理服务哦！快去进阶成为正式创作者吧！ #i18n$')}}</p>
      <div class="btn-register" @click="developerClick">
        <router-link to="/examination">{{$vi18n('$i18n# 去答题转正 #i18n$')}}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
// import { RegistryReferer } from '@/types';
// import { createRegisterUrl } from '@/utils';
// import {reportData} from '@/main.js'
import { mapState } from 'vuex';
export default {
  props: {
    height: {
      type: Number,
      default: 0,
    },
    left: {
      type: Number,
      default: 0,
    },
    homeType: {
      type: Boolean,
      default: false,
    },
    mapType: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      registerUrl:
        'https://dev-wiki.mini1.cn/cyclopdeia?wikiMenuId=1634&wikiId=805', // createRegisterUrl(RegistryReferer.MapData),
      iconArr: [
        {
          name: this.$vi18n('$i18n# 账号管理 #i18n$'),
          img: require('@/assets/images/icon_mask_user.png'),
        },
        {
          name: this.$vi18n('$i18n# 收益管理 #i18n$'),
          img: require('@/assets/images/icon_mask_money.png'),
        },
      ],
      userTxt: this.$vi18n('$i18n# 开发者 #i18n$'),
      // developerInfo
    };
  },
  computed: {
    ...mapState(['developerInfo', 'userInfo']),
  },
  mounted() {
    this.becomeDShow();
    let version = '';
    //$vi18n('$i18n# 判断是否是 #i18n$')427$vi18n('$i18n# 版本 #i18n$')
    if (this.userInfo.ver) {
      let ver = this.userInfo.ver.split('.');
      version =
        (parseInt(ver[0]) << 16) + (parseInt(ver[1]) << 8) + parseInt(ver[2]);
      if (version >= 68608) {
        this.userTxt = this.$vi18n('$i18n# 开发者 #i18n$');
      } else {
        this.userTxt = this.$vi18n('$i18n# 开发者 #i18n$');
      }
    }
  },
  methods: {
    developerClick() {
      //$vi18n('$i18n# 首页 #i18n$')-$vi18n('$i18n# 认证开发者点击埋点 #i18n$')
      if (this.homeType) {
        this.$log('approve_developer_click', 85406, { v7: 1 });
      }
      //$vi18n('$i18n# 地图 #i18n$')-$vi18n('$i18n# 认证开发者按钮点击 #i18n$')
      if (this.mapType) {
        this.$log('become_developer_click', 85409, { v7: 1 });
      }
    },
    //$vi18n('$i18n# 地图 #i18n$')-$vi18n('$i18n# 认证开发者按钮展示 #i18n$')
    becomeDShow() {
      this.$log('become_developer_show', 85408, { v7: 1 });
    },
  },
};
</script>

<style lang="scss" scoped>
.mask {
  position: absolute;
  z-index: 99;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 8px;
}
.mask-content {
  flex-direction: column;
  // position: absolute;
  // z-index: 99;
  // top: 0;
  width: 100%;
  height: 100%;
  
}
.icon-wrap {
  width: 70%;
}
.icon-item {
  flex-direction: column;
  justify-content: space-around;
  p {
    color: #5c5c5c;
    font-size: 16px;
  }
  img:hover {
    filter: brightness(95%);
  }
  img {
    width: 80px;
  }
}
.explain {
  font-size: 20px;
  color: #6e6969;
}
.btn-register {
  // width: 200px;
  padding: 0 10px;
  height: 50px;
  font-size: 20px;
  background: #fd9b21;
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
  line-height: 50px;
  &:hover {
    filter: brightness(95%);
  }
  > a {
    display: block;
  }
}

.flex {
  display: flex;
  align-items: center;
  justify-content: space-around;
  a {
    color: #fff;
    text-decoration: none;
  }
}
</style>
